<template>
  <v-dialog v-model="dialog" persistent width="60vw" height="60vw">
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        small
        tile
        outlined
        depressed
        dark
        v-on="on"
        @click="dialog = true"
        class="mx-1"
        ><v-icon small color="primary">mdi-plus</v-icon>
        Add Invoice(s)
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Select invoices to apply to this payment</v-card-title>
      <v-card-text>
        Search by
        <v-btn-toggle v-model="searchBy" borderless dense color="accent">
          <v-btn value="client">Client</v-btn>
          <v-btn value="batch">Batch</v-btn>
        </v-btn-toggle>
      </v-card-text>
      <invoice-lookup
        v-if="dialog && searchBy === 'client'"
        :pendingSessions="pendingSessions"
        @setSelected="setSelected"
      ></invoice-lookup>
      <invoice-batch-lookup
        v-if="dialog && searchBy === 'batch'"
        :pendingBatches="pendingBatches"
        @setSelected="setSelected"
      ></invoice-batch-lookup>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text :disabled="loading" @click="clear">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          outlined
          :dark="!invalid && !loading"
          :disabled="invalid || loading"
          @click="apply"
          >Apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import InvoiceLookup from "./invoice-lookup.vue";
import InvoiceBatchLookup from "./invoice-batch-lookup.vue";
export default {
  components: { InvoiceLookup, InvoiceBatchLookup },
  data() {
    return {
      dialog: false,
      loading: false,
      selected: [],
      searchBy: "client",
    };
  },
  computed: {
    invalid() {
      return this.selected.length === 0;
    },
    batchId() {
      return this.$store.state.paymentBatchModule.selectedBatch?.paymentBatchId;
    },
    pendingSessions() {
      return this.$store.state.paymentBatchModule.selectedBatch?.invoicePayments.map(
        (item) => item.sessionId
      );
    },
    pendingBatches() {
      return this.$store.state.paymentBatchModule.selectedBatch?.invoiceBatches.map(
        (item) => item.invoiceBatchId
      );
    },
  },
  methods: {
    setSelected(value) {
      this.selected = value;
    },
    async apply() {
      this.loading = true;
      let message = "";
      if (this.searchBy === "client") {
        for await (const invoice of this.selected) {
          await this.$store.dispatch("paymentBatchModule/addInvoiceToBatch", {
            paymentBatchId: this.batchId,
            sessionInvoiceId: invoice.sessionInvoiceId,
          });
        }
      } else if (this.searchBy === "batch") {
        for await (const invoiceBatch of this.selected) {
          message += await this.$store.dispatch(
            "paymentBatchModule/addInvoiceBatchToPaymentBatch",
            {
              paymentBatchId: this.batchId,
              invoiceBatchId: invoiceBatch.invoiceBatchId,
            }
          );

          if (message) {
            this.$store.commit("uxModule/setSnackbarMsg", message);
            this.$store.commit("uxModule/setShowSnackbar", true);
          }
        }
      }

      this.loading = false;
      this.clear();
    },
    clear() {
      this.searchBy = "client";
      this.dialog = false;
    },
  },
};
</script>
